import type { PracticeKind } from './types';

/**
 * Обложка ролевой игры — маскот в сцене (`public/roleplay/*.webp`, 512×512,
 * ~9 КБ; исходники и генератор — `scripts/scenes/generate-roleplay-scenes.mjs`).
 * Ключ — имя иконки lucide, которое уже хранит бэк (см. seed-practice.ts), как
 * у `practiceEmojiFor`: немецкие и португальские зеркала сцен получают ту же
 * картинку. У идиом обложек пока нет — `null`, карточка рисует иконку.
 */
const ICON_COVER: Record<string, string> = {
  Map: 'road-trip',
  Gift: 'souvenirs',
  Headset: 'tech-support',
  BookOpen: 'book-plot',
  Briefcase: 'job-interview',
  Home: 'show-your-place',
  UtensilsCrossed: 'restaurant',
  PackageX: 'return-item',
  BedDouble: 'hotel-check-in',
  Stethoscope: 'doctor',
  Car: 'car-rental',
  Scissors: 'hair-salon',
  Phone: 'book-table',
  Users: 'noisy-neighbor',
  PartyPopper: 'party',
  TrendingUp: 'raise',
  Plane: 'flight-delay',
  PawPrint: 'vet',
  Landmark: 'bank-account',
  Dumbbell: 'personal-training',
};

export function practiceCoverFor(icon: string | null, kind: PracticeKind): string | null {
  if (kind !== 'roleplay' || !icon || !ICON_COVER[icon]) return null;
  return `/roleplay/${ICON_COVER[icon]}.webp`;
}

/**
 * Фон сцены за тьютором в чате ролевой игры (`public/roleplay-bg/*.webp`,
 * 1280×720 в блюре; генератор — `scripts/scenes/generate-tutor-backgrounds.mjs
 * roleplay`): тот же slug, что у обложки. Null — сцена без своего фона, тогда
 * за тьютором остаётся его собственный.
 */
export function practiceBackdropFor(roleplayIcon: string | null | undefined): string | null {
  if (!roleplayIcon || !ICON_COVER[roleplayIcon]) return null;
  return `/roleplay-bg/${ICON_COVER[roleplayIcon]}.webp`;
}
